import React from "react";

// You can use the favicon or a logo image
const CLAMALO_LOGO_URL = "https://app.clamalo.com/favicon.ico";

const ClamaloSpinner: React.FC<{ size?: number }> = ({ size = 48 }) => (
  <img
    src={CLAMALO_LOGO_URL}
    alt="Clou Spinner"
    style={{
      width: size,
      height: size,
      animation: "clamalo-spin 1s linear infinite",
      display: "block",
      margin: "0 auto"
    }}
  />
);

export default ClamaloSpinner;

// Add the animation to global CSS (index.css or App.css):
// @keyframes clamalo-spin {
//   0% { transform: rotate(0deg); }
//   100% { transform: rotate(360deg); }
// } 